export const GET_PIN_VALIDATION_REQUEST = "GET_PIN_VALIDATION_REQUEST"
export const GET_PIN_VALIDATION_RESPONSE_SUCCESS = "GET_PIN_VALIDATION_RESPONSE"
export const GET_PIN_VALIDATION_RESPONSE_FAIL = "GET_PIN_VALIDATION_RESPONSE_FAIL"
